import React from 'react';
import {View} from 'react-native';
import { Actions } from '../../navigation';
import PropTypes from 'prop-types';
import PostRedirectLoader from './PostRedirectLoader';
import {
  getBookingSuccessCallbackUrlPWA,
  getForgotPasswordButtonCallbackURL,
  getMmtId,
  verifyBookingStatus
} from './PostPaymentUtils';

import RailsBookingSuccess from './RailsBookingSuccess';
import RailsBookingFailure from './RailsBookingFailure';
import RailsBookingPending from './RailsBookingPending';

export const STATUS_LOADING = 'LOADING';
export const STATUS_SUCCESS = 'SUCCESS';
export const STATUS_PENDING = 'PENDING';
export const STATUS_FAILURE = 'FAILURE';

class verifyIrctcBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bookingStatus: STATUS_LOADING,
      mmtId: ''
    };
  }

  async _isSuccessCallBackUrlPWA() {
    const mmtId = await getMmtId();
    this.setState({mmtId});
    const callBackURL = await getBookingSuccessCallbackUrlPWA(mmtId);
    return this.props.request.indexOf(callBackURL) > -1 ||
      this.props.request.startsWith(callBackURL);
  }

  // fixme understand why interception is not working for forgotcallbackurl
  async _isForgotPasswordCallBackURL() {
    if (
      this.props.request === 'https://rails.makemytrip.com/pwa/thankyouIntermediate' ||
      this.props.request === 'http://rails.makemytrip.com/pwa/thankyouIntermediate'
    ) {
      return true;
    }
    const mmtId = await getMmtId();
    const callBackURL = await getForgotPasswordButtonCallbackURL(mmtId);
    return this.props.request.indexOf(callBackURL) > -1 ||
        this.props.request.startsWith(callBackURL);
  }

  async componentWillMount() {
    let bookingStatus;
    if (await this._isSuccessCallBackUrlPWA()) {
      const status = await verifyBookingStatus(this.props.request);
      switch (status) {
        case STATUS_SUCCESS:
          bookingStatus = STATUS_SUCCESS;
          break;
        case STATUS_PENDING:
          bookingStatus = STATUS_PENDING;
          break;
        case STATUS_FAILURE:
          bookingStatus = STATUS_FAILURE;
          break;
        default:
          bookingStatus = STATUS_PENDING;
      }
    } else if (await this._isForgotPasswordCallBackURL()) {
      Actions.forgotPassword({type: 'replace'});
      return;
    } else {
      bookingStatus = STATUS_PENDING;
    }
    this.setState({
      bookingStatus
    });
  }

  render() {
    const {bookingStatus} = this.state;
    return (
      <View style={{flex: 1}}>
        {bookingStatus === STATUS_LOADING &&
          <PostRedirectLoader />
          }

        {bookingStatus === STATUS_SUCCESS &&
          <RailsBookingSuccess rootTag={this.props.rootTag} />
          }
        {bookingStatus === STATUS_FAILURE &&
          <RailsBookingFailure rootTag={this.props.rootTag}  />
          }
        {bookingStatus === STATUS_PENDING &&
          <RailsBookingPending rootTag={this.props.rootTag}  />
          }
      </View>
    );
  }
}

verifyIrctcBooking.propTypes = {
  request: PropTypes.string.isRequired
};
export default verifyIrctcBooking;
